import { createClient } from '@supabase/supabase-js';
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
export const productionAuthEnabled = Boolean(url && anon && import.meta.env.VITE_DEMO_MODE === 'false');
export const supabase = productionAuthEnabled ? createClient(url!, anon!, { auth: { persistSession: true, autoRefreshToken: true } }) : null;
export async function accessToken() {
  if (!supabase) return null;
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
